export const trackEvent = (event, eventName, properties = {}) => {
    dataLayer.push({
        'event': event,
        'eventName': eventName,
        'properties': properties
    });
};
